export const colors = {
  obsidian: {
    base: "#0A0F1D",
    deep: "#0B132B",
  },
  safety: "#FF5B00",
  white: "#FFFFFF",
  cad: "#475569",
  energy: "#10B981",
  amber: "#F59E0B",
} as const;

export const fonts = {
  display: '"Space Grotesk", ui-sans-serif, system-ui, sans-serif',
  body: 'Inter, ui-sans-serif, system-ui, sans-serif',
  mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, monospace',
} as const;

export const timing = {
  splashMinMs: 1600,
  splashExitMs: 420,
} as const;
